// TODO: TBD use MUI validation or custom
import React, { useContext, useState } from 'react';
import { Auth } from 'aws-amplify';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import styles from './verifyEmail.module.scss';
import { di } from '../../state/inversify.config';
import { LoginDomainService } from '../login/loginDomainService';
import { UserNotificationContext } from '../../components/userNotification/userNotificationContext';
import { UserNotificationType } from '../../components/userNotification/userNotificationType.enum';
import { TextInput } from '../../components/textInput/textInput';
import { Button } from '../../components/button/button';
import { Spinner } from '../../components/spinner/spinner';

interface VerifyEmailProps {
  email: string;
  password: string;
}

export function VerifyEmail({ email, password }: VerifyEmailProps) {
  const { t } = useTranslation();

  const { addUserNotification } = useContext(UserNotificationContext);

  const loginDomainService = di.get<LoginDomainService>(LoginDomainService);

  const [inputs, setInputs] = useState({
    verificationCode: '',
  });
  const [isSendingConfirmationCode, setIsSendingConfirmationCode] =
    useState(false);
  const [isVerifyingUser, setIsVerifyingUser] = useState(false);

  const confirmSignUp = async () => {
    setIsVerifyingUser(true);
    await Auth.confirmSignUp(email, inputs.verificationCode)
      .then(() => {
        Auth.signIn(email, password)
          .then(() => {
            loginDomainService.dispatchLogin({
              email,
              password,
            });
          })
          .catch((_error) => {
            addUserNotification(
              UserNotificationType.ERROR,
              _error.message,
              UserNotificationType.ERROR,
            );
            setIsVerifyingUser(false);
          });
      })
      .catch((_error) => {
        addUserNotification(
          UserNotificationType.ERROR,
          _error.message,
          UserNotificationType.ERROR,
        );
        setIsVerifyingUser(false);
      });
  };

  const resendConfirmationCode = async (_email: string) => {
    setIsSendingConfirmationCode(true);
    await Auth.resendSignUp(_email)
      .then(() => {
        addUserNotification(
          UserNotificationType.SUCCESS,
          t('CODE_SENT'),
          UserNotificationType.SUCCESS,
        );
        setIsSendingConfirmationCode(false);
      })
      .catch((_error) => {
        setIsSendingConfirmationCode(false);
        addUserNotification(
          UserNotificationType.ERROR,
          _error.message,
          UserNotificationType.ERROR,
        );
      });
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;

    setInputs((values) => ({ ...values, [name]: value }));
  };

  return (
    <div className={styles.mainContainer}>
      <div className={styles.container}>
        <Typography component="h1" variant="h4" sx={{ textAlign: 'center' }}>
          {t('CHECK_YOUR_EMAIL')}
        </Typography>
        <p>{t('CONFIRMATION_CODE_SENT')}</p>
        {isVerifyingUser ? (
          <Spinner
            open={isVerifyingUser}
            text={t('VERIFY_CONFIRMATION_CODE') || ''}
          />
        ) : (
          <>
            <TextInput
              type="number"
              label={t('ENTER_VERIFICATION_CODE')}
              name="verificationCode"
              autoFocus
              fullWidth
              required
              onChange={handleInputChange}
              value={inputs.verificationCode}
            />

            <Button
              color="secondary"
              type="submit"
              testId="verifyEmail"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
              onClick={confirmSignUp}
              label={t('VERIFY')}
            />
          </>
        )}
        {isSendingConfirmationCode ? (
          <Spinner
            open={isSendingConfirmationCode}
            text={t('SENDING_CONFIRMATION_CODE') || ''}
          />
        ) : (
          <Button
            color="secondary"
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
            onClick={() => resendConfirmationCode(email)}
            label={t('RESEND_CONFIRMATION_CODE')}
          />
        )}
        <span className={styles.alreadyVerified}>
          {t('ALREADY_VERIFIED')}
          <Link to="/" onClick={() => window.location.reload()}>
            {t('SIGN_IN')}
          </Link>
        </span>
      </div>
    </div>
  );
}
